<template>
  <v-container v-if="this.zamawiajacy" class="page">
<table>
  <thead>
  <tr><td>

<div class="cointainer caption" style="margin-top: 0px; margin-bottom: 10px;">
  <div class="left-cointainer">
    <img height="50" class="mt-1" contain src="/static/img/logo-tutore-small.svg">
  </div>
  <div class="right-cointainer">
    Tutore Poland Sp. z o.o.<br>
    ul. Piotrkowska 157A, 90-440 Łódź<br>
    NIP: 7272812193
  </div>
</div>

  </td></tr>
  </thead>
<tbody>
<tr><td>
<p align="center" style="margin-top:20px;">
    <strong>UMOWA O ŚWIADCZENIE USŁUG</strong>
</p>
<p>
    zawarta w Łodzi pomiędzy:
</p>
<p>
  <strong>Tutore Poland Sp. z o.o.</strong>
  , z siedzibą w Łodzi przy ul. Piotrkowska 157A, (kod: 90-440)  NIP 7272812193,
  REGON 366891567, wpisaną do rejestru przedsiębiorców pod numerem KRS: 0000670834, sąd rejestrowy: Sąd
  Rejonowy dla Łodzi – Śródmieścia w Łodzi, XX Wydział Gospodarczy KRS, reprezentowanym/ą przez:
</p>
<p>
  <strong>{{zamawiajacy}}</strong>, zwanym/zwaną dalej <strong>Zleceniodawcą</strong>,
</p>
<p>
  a
</p>
<p>
  <strong>Panią/Panem</strong>
  <br/>
  Imię i Nazwisko: {{imieNazwisko}}
  <br/>
  PESEL: {{pesel}}
  <br/>
  Nr Dowodu Osobistego: {{nrDowodu}}
  <br/>
  Adres zamieszkania: {{zamieszkany}}
  <br/>
  <span v-if="korespondencyjnyFirmy">
    Adres do korespondencji: {{korespondencyjnyFirmy}}
    <br/>
  </span>
  Nr telefonu: {{nrTelefonu}}
  <br/>
  e-mail: {{email}}
  <br/>
  Nr konta bankowego: {{nrRachunku}}
  <br/>
</p>
<p>
  prowadzącym/ą działalność gospodarczą pod <strong>firmą</strong>:
  <br/>
   Nazwa firmy: {{nazwaFirmy}}
   <br/>
   Siedziba firmy: {{adresFirmy}}
   <br/>
   NIP: {{NIP}}
   <br/>
</p>
<p>
  zwanym/zwaną w dalszej części umowy <strong>Zleceniobiorcą</strong> o następującej treści:
</p>
<p align="center" style="margin-bottom: 0px;">
  <strong>§ 1 Przedmiot umowy</strong>
</p>
<div>
  1. Zleceniodawca oświadcza, iż jest właścicielem brandów i znaków towarowych 2Can School oraz 2Can Kids oraz metody, materiałów, szkoleń związanych z nauką języka angielskiego (oraz innych języków obcych), metodami nadzoru, współpracy oraz materiałów dydaktycznych w formie drukowanej oraz online.
  <br/>
  2. Zleceniodawca zleca, a Zleceniobiorca zobowiązuje się do wykonywania czynności polegających na:
  <br/>
  a) rzetelnym  przygotowaniu  i prowadzeniu zajęć zdalnych z języka angielskiego zgodnie z programem edukacyjnym szkoły 2Can oraz harmonogramem  zajęć - uzgodnionym, przekazanym i akceptowanym przez Strony przed podpisaniem Umowy. Harmonogram może mieć formę pliku elektronicznego;
  <br/>
  b) przygotowywaniu, przeprowadzaniu i sprawdzaniu indywidualnych testów poziomujących wraz ze sprawdzeniem i omówieniem. (Test diagnostyczny pozwalający przydzielić danego ucznia do grupy zajęciowej);
  <br/>
  c) prowadzeniu dokumentacji zajęć, tj.: dziennika zajęć, listy obecności, listy testów, gier i zabaw, sprawozdania z realizacji zajęć;
  <br/>
  d) terminowym wykonywaniu wszystkich wytycznych organizacyjnych Zleceniodawcy w terminach przez niego określonych,
  <br/>
  e) Współpracy z osobami i podmiotami współpracującymi ze Zleceniodawcą, w tym w szczególności z koordynatorami oraz metodykami szkoły 2Can oraz innymi osobami wyznaczonym przez Zleceniodawcę do koordynowania pracy w szkole 2Can, przy czym  Zleceniobiorca jest  zobowiązany jest do regularnego i niezwłocznego  (najpóźniej niż na koniec każdego dnia roboczego) odczytywania wiadomości wysyłanych przez te osoby poprzez pocztę e-mail, wiadomości sms lub poprzez komunikatory internetowe i w razie potrzeby jak najszybszego udzielenia odpowiedzi na informacje, w tym szczególnie:
  <br/>
  <p style="margin-left: 40px; margin-bottom: 0px;">
    i) przekazywanie  niezbędnych informacji w zakresie określonym w danej sytuacji;
    <br/>
    ii) udział w zebraniach, rozmowach pohospitacyjnych i ewaluacjach.
    <br/>
  </p>
  f) Współpracy z rodzicami uczniów, w tym szczególnie:
  <br/>
  <p style="margin-left: 40px; margin-bottom: 0px;">
    i) odpisywaniu na maile,
    <br/>
    ii) przekazywaniu prac domowych,
    <br/>
    iii) dwa razy do roku raportowaniu postępów uczniów,
    <br/>
    iii) udziale w spotkaniach z rodzicami.
    <br/>
  </p>
  3. Celem zapewnienia warunków do wykonania niniejszej Umowy, Zleceniodawca zobowiązuje się do udostępnienia wszystkich  niezbędnych materiałów dydaktycznych, takich jak podręczniki, panele edukacyjne, grafiki do prezentacji oraz  indywidualnego konta w systemie do nauki online. Powyższe nie obejmuje sprzętu elektronicznego niezbędnego do prowadzenia zajęć online (komputer, sprzęt nagłaśniający, itp.), które Zleceniobiorca zobowiązany jest zorganizować na własny koszt.
  <br/>
</div>
<p align="center" style="margin-bottom: 0px;">
  <br/>
  <strong>§ 2 Wykonywanie umowy</strong>
</p>
<p>
  1. Zlecone zajęcia Zleceniobiorca będzie wykonywał osobiście i nie może powierzyć ich w całości lub części innym osobom bez pisemnej zgody Zleceniodawcy. Zleceniodawca nie będzie zobowiązany do zapłaty wynagrodzenia Zleceniobiorcy ani osobie trzeciej za wykonanie czynności dokonanych z naruszeniem zakazu, o którym mowa w zdaniu poprzednim. 
  <br/>
  2. Zlecenie nie będzie wykonywane w siedzibie Zleceniodawcy. W przypadku wykonywania zlecenia w siedzibie Zleceniodawcy lub miejscu przez niego wyznaczonym, Zleceniobiorca oświadcza, że zna przepisy i zasady bezpieczeństwa i higieny pracy i zobowiązuje się do ich przestrzegania, a w szczególności do:
  <br/>
  a) wykonywania zlecenia w sposób zgodny z przepisami i zasadami bezpieczeństwa i higieny pracy;
  <br/>
  b) dbania o należyty stan mienia Zleceniodawcy oraz o porządek i ład w miejscu wykonywania zlecenia;
  <br/>
  c) zastosowania szczegółowych wytycznych w zakresie przygotowania miejsca pracy, jego oznakowania oraz identyfikacji miejsca pracy np. (tło, banery, flagi, itp.),
  <br/>
  d) stosowania występujących w miejscu wykonywania zlecenia, dostępnych środków ochrony zbiorowej, a także używania własnych środków ochrony indywidualnej oraz odzieży i obuwia roboczego, o ile charakter wykonywanej pracy tego wymaga;
  <br/>
  e) niezwłocznego zawiadomienia Zleceniodawcy o zauważonym wypadku albo zagrożeniu życia lub zdrowia ludzkiego oraz ostrzeżenia współpracowników i innych osób znajdujących się w rejonie zagrożenia o grożącym im niebezpieczeństwie,
  <br/>
  f) współdziałania ze Zleceniodawcą w czasie ewakuacji, w sytuacji pożaru  oraz w przypadku konieczności udzielenia pomocy ofiarom wypadków.
  <br/>
  2. Zleceniobiorca odpowiedzialny jest za jakość i terminowość prowadzonych zajęć.
  <br/>
  3. Zleceniobiorca ponosi pełną odpowiedzialność za szkody wyrządzone przez swoje działania lub zaniechania podczas wykonywania przedmiotu umowy.
  <br/>
  4. Wykonawca zobowiązany jest do stosowania się do przepisów Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (RODO) oraz Ustawy z dnia 10 maja 2018 r. o ochronie danych osobowych (Dz.U.2019.1781 t.j.).
  <br/>
  5. Zleceniobiorca zobowiązany jest do bezzwłocznego informowania Zleceniodawcy o każdym przypadku uniemożliwiającym mu realizację zajęć zgodnie z harmonogramem. W przypadku niemożności przeprowadzenia zajęć określonych w § 1 w terminach określonych w harmonogramie z jakiejkolwiek przyczyny niezależnej od Zleceniodawcy, Zleceniobiorca zobowiązuje się do niezwłocznego powiadomienia Zleceniodawcy o zaistniałym fakcie,  nie później niż 3 dni przed planowanymi zajęciami. Naruszenie tego zobowiązania będzie uprawniało Zleceniodawcę do żądania kary umownej w wysokości 200 zł (200 zł) za każde nieprzeprowadzone zajęcia, a także odszkodowania przenoszącego wartość zastrzeżonej kary umownej.
  <br/>
  6. W przypadku nagłej niedyspozycji wynikającej z choroby lub złego stanu zdrowia, które wystąpiło nagle, Zleceniobiorca może nie zachować 3 dniowego okresu powiadomienia o niemożności wykonywania zlecenia, jednak jest zobowiązany do poinformowania Zleceniodawcy o takim zdarzeniu niezwłocznie po dowiedzeniu się o nim.
  <br/>
  7. W przypadku braku możliwości realizowania przez Zleceniobiorcę przedmiotu umowy zgodnie z harmonogramem, spowodowanej usprawiedliwioną nieobecnością trwającą w miesiącu nie dłużej niż pięć dni roboczych w sumie lub następujących kolejno po sobie, przy czym przez usprawiedliwioną nieobecność rozumie się wyłącznie nieobecność udokumentowaną zwolnieniem lekarskim lub innym dokumentem urzędowym. 
  <br/>
  8. W przypadku niemożności przeprowadzenia przez Zleceniobiorcę zajęć zaplanowanych według harmonogramu, Zleceniodawca dołoży starań w celu znalezienia zastępstwa i powierzenia przeprowadzenia zajęć innej osobie. Zleceniobiorcy nie przysługuje wynagrodzenie za zajęcia przeprowadzone przez zastępcę. W przypadku gdy Zleceniodawca nie znajdzie zastępstwa, Zleceniobiorca zobowiązany jest do przeprowadzenia zajęć w ilości godzin równej nie odbytym zajęciom, w innym terminie uzgodnionym ze Zleceniodawcą.
  <br/>
  9. Strony dopuszczają zmiany dat i godzin zajęć określonych w harmonogramie wyłącznie za obopólną zgodą.
  <br/>
  10. W przypadku nieprzeprowadzenia zajęć w terminie wynikającym z harmonogramu i nie powiadomienia o tym fakcie Zleceniodawcy z wyprzedzeniem nie mniejszym niż 3 dni przed planowanymi zajęciami, Zleceniodawca może rozwiązać Umowę ze skutkiem natychmiastowym bez zachowania okresu wypowiedzenia. W takim przypadku, niezależnie od możliwości wypowiedzenia Umowy, Zleceniodawca może ponadto dochodzić kary umownej w wysokości trzykrotnej wartości wynagrodzenia, które przysługiwałoby Zleceniobiorcy w przypadku przeprowadzenia zajęć. Zleceniodawca może także dochodzić odszkodowania przenoszącego wartość zastrzeżonej kary umownej. Powyższy zapis nie dotyczy sytuacji losowych uniemożliwiających powiadomienie Zleceniodawcy o niemożliwości  przeprowadzenia zajęć.
  <br/>
  11. Zleceniobiorca zobowiązuje się do używania swoich narzędzi do wykonywania Umowy w postaci komputera/laptopa, kamerki, mikrofonu oraz dostępu do łącza internetowego zapewniającego dostateczną szybkość do prowadzenia zajęć w wersji online. Zleceniobiorcy nie przysługuje dodatkowe wynagrodzenie za wykorzystanie własnego sprzętu do celu wykonania niniejszej Umowy.
  <br/>
</p>
<p align="center" style="margin-bottom: 0px;">
  <strong>§ 3 Wynagrodzenie</strong>
</p>
<div>
  1. Tytułem wynagrodzenia za prawidłowe wykonanie czynności objętych Umową  Zleceniobiorca otrzymuje:
  <br/>
  <p style="margin-left: 40px; margin-bottom: 0px;">
    brutto {{wynagrodzenie}} złotych (słownie: {{wynagrodzenieSlownie}}) za 1 godzinę zegarową zajęć (60 minut).
    <br/>
    brutto 10 złotych (słownie: dziesięć złotych) za przygotowanie, przeprowadzenie i sprawdzenie indywidualnego testu poziomującego wraz ze sprawdzeniem i omówieniem.  (Test diagnostyczny pozwalający przydzielić danego ucznia do grupy zajęciowej)
    <br/>
    brutto 20 złotych (słownie: dwadzieścia  złotych) za przeprowadzenie lekcji pokazowej (40 minut zajęć pozapodręcznikowych)
    <br/>
  </p>
  2. Okresem rozliczeniowym jest miesiąc kalendarzowy. W terminie do 10 dni po upływie każdego miesiąca kalendarzowego Zleceniobiorca przedstawi Zleceniodawcy sprawozdanie z wykonanych czynności. Zleceniodawca zweryfikuje otrzymane sprawozdanie w terminie 10 dni od daty jego otrzymania. Zleceniodawca ma prawo zakwestionować otrzymane sprawozdanie, jeśli wynikające z niego czynności nie zostały zarejestrowane w systemie do nauki online - za takie czynności Zleceniobiorcy nie będzie przysługiwało wynagrodzenie. 
  <br/>
  3. Zleceniodawca wypłaci Zleceniobiorcy wynagrodzenie na podstawie zweryfikowanego sprawozdania, o którym mowa w ust. 2 powyżej, w terminie 10 dni od upływu terminu na jego zweryfikowania, na rachunek bankowy Zleceniobiorcy wskazany w komparycji niniejszej Umowy.
  <br/>
  4. Kwota obliczona zgodnie z § 3 ust. 1 niniejszej umowy stanowi całość przysługującego Zleceniobiorcy wynagrodzenia oraz obejmuje wynagrodzenie za czynności związane z prowadzeniem zajęć online określone w § 1 ust, 1 niniejszej Umowy, takie jak prowadzenie dokumentacji, udział w spotkaniach z rodzicami, itd., a także wszelkie ewentualne wydatki poniesione przez Zleceniobiorcę w celu wykonania niniejszej Umowy.
  <br/>
</div>
<p align="center" style="margin-bottom: 0px;">
  <br/>
  <strong>§ 4 Sposób wykonywania umowy</strong>
</p>
<p>
  Zleceniobiorca zobowiązuje się wykonywać niniejszą umowę z dołożeniem najwyższej staranności oraz z zachowaniem najlepszych standardów nauczania, stosując się do zaleceń i metodyki Zleceniodawcy.
</p>
<br>
<p align="center" style="margin-bottom: 0px;">
  <strong>§ 5 Czas trwania umowy i okres wypowiedzenia</strong>
</p>
<div>
  1. Strony zawierają umowę na czas od dnia podpisania jej przez obie strony do dnia {{umowaDo}}.
  <br/>
  2. Strony mogą rozwiązać Umowę z zachowaniem 2-miesięcznego okresu wypowiedzenia, ze skutkiem prawnym na koniec miesiąca kalendarzowego,  po pisemnym przesłaniu informacji o wypowiedzeniu umowy (z zastrzeżeniem punktu 3 i 4.).
  <br/>
  3. Zleceniodawca ma prawo rozwiązać niniejszą Umowę bez zachowania okresu wypowiedzenia w przypadku określonym w § 2 ust. 11 niniejszej Umowy, a także, jeżeli Zleceniobiorca rażąco sprzeciwia się postanowieniom niniejszej Umowy, przez co strony rozumieją w szczególności:
  <br/>
  <p style="margin-left: 40px; margin-bottom: 0px;">
    a. zachowanie Zleceniobiorcy polegające na niewykonywaniu obowiązków określonych w § 1 ust. 1 niniejszej Umowy, pomimo uprzedniego wezwania ze strony Zleceniodawcy do zaniechania naruszeń;
    <br/>
    b. złamanie przez Zleceniobiorcę zakazu konkurencji;
    <br/>
    c. ujawnienie przez Zleceniobiorcę Informacji Poufnych.
    <br/>
  </p>
</div>
<p align="center" style="margin-bottom: 0px;">
  <br/>
  <strong>§ 6 Informacje poufne</strong>
</p>
<p>
  1. Przez Informacje Poufne strony rozumieją wszelkie informacje przekazane Zleceniobiorcy przez Zleceniodawcę lub uzyskane przez Zleceniodawcę w inny sposób w związku z wykonywaniem niniejszej Umowy, obejmujące informacje techniczne, technologiczne, organizacyjne lub inne informacje posiadające wartość gospodarczą, które dotyczą Zleceniodawcy i jego działalności, a w szczególności materiały dydaktyczne wykorzystywane przez Zleceniodawcę, baza danych kontaktowych do Klientów Zleceniodawcy, systemy komputerowe oraz pozostałe informacje uzyskiwane od Zleceniodawcy w trakcie wykonywania Umowy;
  <br/>
  2. Zleceniobiorca zobowiązuje się, że Informacje Poufne uzyskane w ramach niniejszej Umowy będą utrzymywane w tajemnicy przez Zleceniobiorcę i wykorzystywane wyłącznie wykonania niniejszej Umowy. Informacje Poufne nie będą wykorzystywane w innych celach ani nie będą ujawniane, czy udostępniane osobom trzecim, w całości lub w części. Zobowiązanie do zachowania poufności dotyczy Informacji Poufnych uzyskanych przez Zleceniobiorcę od Zleceniodawcy w formie pisemnej oraz ujawnionych Zleceniobiorcy ustnie, wizualnie, elektronicznie lub w inny sposób. Zleceniobiorca zobowiązuje się utrzymywać otrzymane Informacje Poufne w tajemnicy i nie ujawniać ich komukolwiek bez pisemnej zgody.
  <br/>
  3. Zleceniobiorca, po zakończeniu współpracy Stron, bądź też, przed jej zakończeniem – na każde żądanie Zleceniodawcy - zobowiązany będzie zwrócić Zleceniodawcy wszelkie Informacje Poufne, wraz z dokumentacją i innymi nośnikami, na których zostały one utrwalone, jak również, kopiami dokumentacji lub nośników zawierających takie Informacje. Zleceniobiorca zobowiązuje się do usunięcia z pamięci komputerów oraz innych urządzeń wszystkich otrzymanych lub wykonanych materiałów  w sposób uniemożliwiający ich odtworzenie oraz wykorzystywanie w przyszłości w jakiejkolwiek formie. 
  <br/>
  4. W przypadku naruszenia przez Zleceniobiorcę postanowień § 7 niniejszej Umowy, w szczególności, poprzez niezgodne z tą Umową ujawnienie lub udostępnienie materiałów oraz  Informacji Poufnych, Zleceniobiorca zobowiązany będzie do zapłaty na rzecz Zleceniodawcy kary umownej w wysokości 1000 zł (słownie: tysiąc złotych) za każde takie naruszenie. Kara taka płatna będzie w terminie 14 dni od daty złożenia przez Zleceniodawcę oświadczenia o obciążeniu Zleceniobiorcy karą umową. 
  <br/>
  5. Jeżeli wysokość szkody lub utraconych korzyści Zleceniodawcy wynikających z naruszenia przez Zleceniobiorcę postanowień niniejszej Umowy przewyższać będzie wysokość kary umownej wskazanej w ust. 4 powyżej., Zleceniodawca może dochodzić odszkodowania uzupełniającego na zasadach ogólnych wynikających z Kodeksu cywilnego.
  <br/>
  6. Za naruszenie zasad opisanych §7 niniejszej Umowy Zleceniodawca uznaje także każdorazowe wykorzystanie materiałów dydaktycznych Zleceniodawcy do prywatnych celów Zleceniobiorcy oraz do celów nauczania osób, które nie są Klientami Zleceniodawcy.
  <br/>
  7. Niezależnie od wygaśnięcia czy rozwiązania niniejszej Umowy, zobowiązania Zleceniobiorcy zachowania w poufności Informacji Poufnych pozostają w mocy bezterminowo, a w przypadku, gdyby zastrzeżenie takie uznane zostało za bezskuteczne, w terminie 2 lat od dnia ich udostępnienia.
  <br/>
</p>
<p>
</p>
<p align="center" style="margin-bottom: 0px;">
  <strong>§ 7 Zakaz konkurencji</strong>
</p>
<p>
  1. Za działalność  konkurencyjną  w  rozumieniu  niniejszego paragrafu Strony uznają: oferowanie lub świadczenie przez Zleceniodawcę jakichkolwiek usług edukacyjnych związanych z nauczaniem języka w jakiejkolwiek formie wobec klientów Zleceniodawcy, którzy zawarli umowę ze Zleceniodawcą najpóźniej w dniu wygaśnięcia niniejszej Umowy. 
  <br/>
  2. Zleceniobiorca zobowiązuje się w czasie  trwania  współpracy  opisanej  niniejszą umową  nie prowadzić  działalności konkurencyjnej  względem  działalności  Zamawiającego wg definicji przedstawionej w punkcie 7.1.
  <br/>
  3. Jeżeli to Klient, który jest aktualnym Klientem Zleceniodawcy, sam złoży propozycję współpracy Zleceniobiorcy, Zleceniobiorca ma obowiązek poinformowania Klienta o ww. zakazie działalności konkurencyjnej i odmówienia podjęcia współpracy oraz jest zobligowany do poinformowania Zleceniodawcy o zaistniałej sytuacji. 
  <br/>
  4. Zleceniodawca zastrzega sobie prawo do sprawdzenia względem Zleceniobiorcy, czy zapisy ww. paragrafu są należycie wykonywane przez Zleceniobiorcę.
  <br/>
  5. Za każdorazowe złamanie zakazu konkurencji, o którym mowa w niniejszym § 7, Zleceniodawca może naliczyć Zleceniobiorcy karę w wysokości 6 000 zł (słownie: sześć tysięcy złotych). W takim przypadku Zleceniodawca może dochodzić także odszkodowania przenoszącego wartość zastrzeżonej kary umownej.
  <br/>
</p>
<p align="center" style="margin-bottom: 0px;">
  <strong>§ 8 Forma umowy</strong>
</p>
<p>
  1. Zmiany niniejszej umowy wymagają formy pisemnej pod rygorem nieważności.
  <br/>
  2. W sprawach nieuregulowanych niniejszą umową mają zastosowanie przepisy Kodeksu Cywilnego.
  <br/>
</p>
<p align="center" style="margin-bottom: 0px;">
  <strong>§ 9 Właściwy Sąd</strong>
</p>
<p>
  Do rozpoznania sporów wynikających z niniejszej umowy właściwy będzie Sąd Powszechny w Łodzi.
</p>
<p align="center" style="margin-bottom: 0px;">
  <strong>§ 10 Ilość umów</strong>
</p>
<p>
  Umowę sporządzono w dwóch jednobrzmiących egzemplarzach, po jednym dla każdej ze stron.
</p>
<div class="cointainer" style="margin-top: 90px;">
  <div class="cointainer-left">
    <span style="margin-left: 15%; white-space: nowrap;">{{zamawiajacy}}<br/></span>
    <span style="margin-left: 15%;"><strong>Zleceniodawca</strong></span>
  </div>
  <div class="cointainer-right">
    <span style="margin-left: 15%; white-space: nowrap;">{{imieNazwisko}}<br/></span>
    <span style="margin-left: 15%;"><strong>Zleceniobiorca</strong></span>
  </div>
</div>

<div style="margin-top:40px;page-break-before: always;">
<p align="center" class="subheading"><strong>Informacja o ochronie danych osobowych </strong></p>
<p>&nbsp;</p>
<p><span>
  Zgodnie z art. 13 Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 
  z dnia 27 kwietnia 2016 r. w sprawie ochrony os&oacute;b fizycznych w związku 
  z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych 
  oraz uchylenia dyrektywy 95/46/WE og&oacute;lne rozporządzenie o ochronie danych, 
  (&bdquo;Rozporządzenie&rdquo;) informujemy, że Administratorem Danych Osobowych jest: 
</span></p>
<p>&nbsp;</p>
<p><em>
  <span>
    Tutore Poland Sp. z o.o. z siedzibą w Łodzi przy 
    ul. Piotrkowska 157A, 90-440 Ł&oacute;dź, 
    wpisana do rejestru przedsiębiorc&oacute;w pod numerem KRS: 0000670834, 
    sąd rejestrowy dla Łodzi Śr&oacute;dmieścia, XX Wydział Krajowego Rejestru Sądowego, 
    NIP: 7272812193.
  </span>
</em></p>
<p>
  <span>
    Kontakt z Administratorem Danych Osobowych możesz uzyskać pisemnie, 
    kierując korespondencję na powyższy adres lub elektronicznie, korzystając z adresu e-mail: 
  </span>
  <a href="mailto:kadry@szkolam.pl"><span>kadry@szkolamm.pl</span></a>
</p>
<p>&nbsp;</p>
<p><span>
  Dane osobowe są przetwarzane w celu zawarcia i realizacji zawartej umowy, 
  tj. na podstawie art. 6 ust. 1 lit. b &nbsp;Rozporządzenia. 
  Podanie danych jest dobrowolne, jednak konieczne w celu zawarcia i wykonania Umowy. 
  W związku z realizacją usług dane osobowe zostaną przekazane podmiotom zewnętrznym, 
  w tym w szczeg&oacute;lności dostawcom system&oacute;w i usług informatycznych, 
  bankom i operatorom płatności, podmiotom świadczącym usługi księgowe,prawne, audytowe, 
  konsultingowe, kurierom, oraz podmiotom powiązanym z Administratorem, 
  kt&oacute;rzy zajmują się realizacją zam&oacute;wień. Dane osobowe będą przechowywane 
  przez okres trwania umowy, a po jej zakończeniu przez czas wynikający z obowiązujących 
  przepis&oacute;w prawa lub do czasu przedawnienia wzajemnych roszczeń. Każda osoba, 
  kt&oacute;rej dane dotyczą ma prawo dostępu do swoich danych osobowych, żądania 
  ich sprostowania, usunięcia, ograniczenia przetwarzania, prawo wniesienia sprzeciwu 
  wobec przetwarzania danych oraz prawo do przenoszenia danych. 
  W celu realizacji powyższych uprawnień należy skontaktować się 
  z Administratorem Danych Osobowych, korzystając z danych teleadresowych, 
  wskazanych powyżej. Osoba, kt&oacute;rej dane dotyczą ma także prawo wniesienia skargi 
  do organu nadzorczego, gdy uzna, iż przetwarzanie danych osobowych narusza przepisy prawa.
  </span></p>
</div>

<div style="margin-top: 40px; page-break-before: always;">

<p align="center"><strong>Umowa powierzenia przetwarzania danych osobowych</strong></p>
<p>&nbsp;</p>
<p><span>(zwana dalej &bdquo;Umową&rdquo;) zawarta pomiędzy: </span></p>
<p><strong>Tutore Poland sp&oacute;łka z ograniczoną odpowiedzialnością </strong>
<span>
  z siedzibą w Łodzi przy ul. Piotrkowska 157A, 90-440 Ł&oacute;dź, 
  wpisaną do rejestru przedsiębiorc&oacute;w pod numerem KRS: 0000670834, 
  sąd rejestrowy: Sąd Rejonowy dla Łodzi-Śr&oacute;dmieścia w Łodzi, XX Wydział Gospodarczy KRS, 
  NIP: 7272812193, REGON: 366891567,
</span>
</p>
<p><span>reprezentowaną przez: </span>
<strong>{{zamawiajacy}}</strong><span>, zwaną/zwanego </span>
<span>w dalszej części umowy </span><strong>&bdquo;Administratorem&rdquo;</strong></p>
<p><span>oraz</span></p>
<p>Nazwa firmy: {{nazwaFirmy}}
<br/>
Siedziba firmy: {{adresFirmy}}
<br/>
<span v-if="korespondencyjnyFirmy">
  Adres do korespondencji: {{korespondencyjnyFirmy}}
  <br/>
</span>
NIP: {{NIP}}
<br/>
Regon: {{REGON}}
<br/>
Tel: {{nrTelefonu}}
<br/>
email: {{email}}
</p>
<p><span>Imię i Nazwisko: {{imieNazwisko}}</span><br />
<span>Adres Zamieszkania: {{zamieszkany}}</span><br />
<span>PESEL: {{pesel}}</span></p>
<p>
  <span>zwanym/zwaną w dalszej części umowy </span>
  <strong>&bdquo;Podmiotem przetwarzającym&rdquo;</strong>
</p>
<p><strong>Preambuła</strong></p>
<p><span>Zważywszy iż:</span></p>
<ul>
<li><span>
  Strony łączy umowa z dnia {{(new Date().toJSON().slice(0, 10).replace(/(\d+)-(\d+)-(\d+)/, '$3-$2-$1'))}} 
  o świadczenie usług polegających na przygotowaniu bazy danych os&oacute;b zainteresowanych usługami sp&oacute;łki 
  (zwana dalej: &bdquo;Umową podstawową&rdquo;);
</span></li>
<li><span>
  w związku z zawarciem i wykonywaniem Umowy konieczne jest powierzenie Podmiotowi przetwarzającemu 
  przez Administratora danych osobowych w trybie art.&nbsp;28 rozporządzenia Parlamentu Europejskiego 
  i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony os&oacute;b fizycznych 
  w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych 
  oraz uchylenia dyrektywy 95/46/WE (og&oacute;lnego rozporządzenia o ochronie danych) 
  (Dz.U.UE.L.2016.119.1) &ndash; zwanego dalej: &bdquo;Rozporządzeniem&rdquo;,
  </span></li>
</ul>
<p style="margin-top: 20px;"><span>Strony postanowiły zawrzeć umowę o następującej treści:</span></p>
<p align="center" style="margin-bottom: 0px;">
  <strong>§1 Powierzenie przetwarzania danych osobowych</strong>
</p>
<ol>
<li><span>Mając na uwadze treść art. art. 28 Rozporządzenia, Administrator danych powierza Podmiotowi przetwarzającemu dane osobowe do przetwarzania, na zasadach &nbsp;i w celu określonym w niniejszej umowie.</span></li>
<li><span>Zawarcie niniejszej umowy powierzenia stanowi udokumentowane polecenie Administratora do przetwarzania danych przez Podmiot przetwarzający.</span></li>
<li><span>Podmiot przetwarzający zobowiązuje się przetwarzać powierzone mu dane osobowe zgodnie z niniejszą umową, Rozporządzeniem oraz z innymi przepisami prawa powszechnie obowiązującego, kt&oacute;re chronią prawa os&oacute;b, kt&oacute;rych dane dotyczą.</span></li>
<li><span>Podmiot przetwarzający oświadcza, iż stosuje techniczne i organizacyjne środki zapewniające bezpieczeństwo danych i ochronę praw os&oacute;b, kt&oacute;rych one dotyczą oraz &nbsp;spełniające wymogi Rozporządzenia. </span></li>
</ol>
<p>&nbsp;<br><br></p>
<p align="center" style="margin-bottom: 0px;">
  <strong>§2 Zakres i cel przetwarzania danych</strong>
</p>
<ol>
<li><span>Podmiot przetwarzający będzie przetwarzał powierzone na podstawie niniejszej umowy następujące dane:</span></li>
</ol>
<p>&nbsp;</p>
<table style="border: 1px solid; text-align: left;">
<tbody>
<tr>
<td style="border: 1px solid;">
<p style="margin-top: 10px; margin-left: 10px; margin-right: 10px;"><span>Kategorie os&oacute;b, kt&oacute;rych dotyczy przetwarzanie</span></p>
</td>
<td>
<p style="margin-top: 10px; margin-left: 10px; margin-right: 10px;"><span>Rodzaj danych osobowych</span></p>
</td>
<td style="border: 1px solid;">
<p style="margin-top: 10px; margin-left: 10px; margin-right: 10px;"><span>Czy powierzone dane osobowe obejmują szczeg&oacute;lne kategorie danych?</span></p>
</td>
<td style="border: 1px solid;">
<p style="margin-top: 10px; margin-left: 10px; margin-right: 10px;"><span>Zakres przetwarzania</span></p>
</td>
<td style="border: 1px solid;">
<p style="margin-top: 10px; margin-left: 10px; margin-right: 10px;"><span>Forma przetwarzania</span></p>
</td>
</tr>
<tr>
<td style="border: 1px solid;">
<p style="margin-top: 10px; margin-left: 10px; margin-right: 10px;"><span>dane osobowe dzieci i ich rodzic&oacute;w/opiekun&oacute;w prawnych </span></p>
</td>
<td style="border: 1px solid;">
<p style="margin-top: 10px; margin-left: 10px; margin-right: 10px;"><span>Imię i nazwisko dziecka, nr tel., PESEL, adres zamieszkania, e-mail, plan zajęć dziecka</span></p>
</td>
<td style="border: 1px solid;">
<p style="margin-top: 10px; margin-left: 10px; margin-right: 10px;"><span>Nie</span></p>
</td>
<td style="border: 1px solid;">
<p style="margin-top: 10px; margin-left: 10px; margin-right: 10px;"><span>organizowanie, utrwalanie, porządkowanie.</span></p>
</td>
<td style="border: 1px solid;">
<p style="margin-top: 10px; margin-left: 10px; margin-right: 10px;"><span>Elektroniczna i papierowa</span></p>
</td>
</tr>
</tbody>
</table>
<p><br /><br /></p>
<ol>
<li><span>Powierzone przez Administratora dane osobowe będą przetwarzane przez Podmiot przetwarzający wyłącznie w celu wykonania Umowy podstawowej. </span></li>
</ol>
<p align="center" style="margin-bottom: 0px; margin-top: 20px;">
  <strong>§3 Obowiązki podmiotu przetwarzającego</strong>
</p>
<ol>
<li><span>Podmiot przetwarzający zobowiązuje się, przy przetwarzaniu powierzonych danych osobowych, do ich zabezpieczenia poprzez stosowanie odpowiednich środk&oacute;w technicznych i organizacyjnych zapewniających adekwatny stopień bezpieczeństwa odpowiadający ryzyku związanym z przetwarzaniem danych osobowych, o kt&oacute;rych mowa w art. 32 Rozporządzenia. Podmiot przetwarzający zobowiązuje się do regularnej weryfikacji i aktualizacji stosowanych przez niego środk&oacute;w technicznych i organizacyjnych tak, aby zapewnić powierzonym danym osobowym adekwatny stopień ochrony. Podmiot przetwarzający, na każde żądanie Administratora danych, przekaże informacje o stosowanych przez niego środkach organizacyjnych i technicznych związanych z przetwarzaniem danych osobowych.</span></li>
<li><span>Podmiot przetwarzający zobowiązuje się dołożyć należytej staranności przy przetwarzaniu powierzonych danych osobowych.</span></li>
<li><span>Podmiot przetwarzający zobowiązuje się do nadania upoważnień do przetwarzania danych osobowych wszystkim osobom, kt&oacute;re będą przetwarzały powierzone dane w celu realizacji niniejszej umowy. </span></li>
<li><span>Podmiot przetwarzający zobowiązuje się, że osoby, kt&oacute;re będą przetwarzały w jego imieniu dane osobowe powierzone na podstawie niniejszej umowy zostaną dopuszczone do przetwarzania jedynie po odbyciu szkoleń z zakresu ochrony danych osobowych (w szczeg&oacute;lności z ochrony danych osobowych i odpowiedzialności za ochronę tych danych przed niepowołanym dostępem, nieuzasadnioną modyfikacją, zniszczeniem, nielegalnym ujawnieniem lub pozyskaniem danych osobowych). Podmiot przetwarzający oświadcza, że dostęp do danych osobowych będą miały jedynie osoby, dla kt&oacute;rych dostęp ten jest niezbędny do wykonania usług określonych w Umowie gł&oacute;wnej.</span></li>
<li><span>Podmiot przetwarzający zobowiązuje się zapewnić zachowanie powierzonych danych w tajemnicy, o kt&oacute;rej mowa w art. 28 ust 3 pkt b Rozporządzenia. W tym celu Podmiot przetwarzający &nbsp;zobowiązuje do zachowania przetwarzanych danych w tajemnicy osoby, kt&oacute;re upoważnia do przetwarzania danych osobowych w celu realizacji niniejszej umowy, zar&oacute;wno w trakcie zatrudnienia ich w Podmiocie przetwarzającym, jak i po jego ustaniu.</span></li>
<li><span>Podmiot przetwarzający po zakończeniu świadczenia usług związanych </span><span><br /></span><span>z przetwarzaniem usuwa wszelkie dane osobowe powierzone na podstawie niniejszej umowy oraz wszelkie ich istniejące kopie, chyba że prawo Unii lub prawo państwa członkowskiego nakazują przechowywanie danych osobowych.</span></li>
<li><span>Podmiot przetwarzający zobowiązuje się wsp&oacute;łpracować z Administratorem w wywiązywaniu się z obowiązku odpowiadania na żądania osoby, kt&oacute;rej dane dotyczą oraz wywiązywania się z obowiązk&oacute;w określonych w art. 32-36 Rozporządzenia. W tym celu Podmiot przetwarzający zobowiązuje się w szczeg&oacute;lności udzielać Administratorowi stosowne informacje lub przekazywać niezbędne dokumenty związane z żądaniem osoby fizycznej i przetworzonymi przez niego danymi osobowymi, nie p&oacute;źniej niż w terminie 7 dni od dnia skierowania stosownego żądania przez Administratora danych</span></li>
<li><span>Podmiot przetwarzający po stwierdzeniu naruszenia ochrony danych osobowych bez zbędnej zwłoki, jednak nie p&oacute;źniej niż w ciągu 24 godzin od chwili powzięcia wiedzy o naruszeniu, zgłasza je Administratorowi. Zgłoszenie będzie zawierać co najmniej opis okoliczności zdarzenia stanowiącego naruszenie ochrony danych osobowych oraz jego ustalonych lub podejrzewanych przyczyn; opis charakteru naruszenia ochrony danych osobowych, w tym w miarę możliwości wskazanie kategorii i przybliżonej liczby os&oacute;b, kt&oacute;rych dane osobowe dotyczą; opis możliwych konsekwencji naruszenia ochrony danych osobowych; opis zastosowanych przez Podmiot przetwarzający środk&oacute;w zaradczych w celu zminimalizowania ewentualnych negatywnych skutk&oacute;w naruszenia ochrony danych osobowych.</span></li>
<li><span>W przypadku stwierdzenia jakiejkolwiek sytuacji stanowiącej naruszenie ochrony danych osobowych lub grożącej takim naruszeniem Podmiot przetwarzający zobowiązany jest:</span></li>

<ol>
<li><span>niezwłocznie, lecz nie p&oacute;źniej niż w ciągu 24 godzin od stwierdzenia takiej sytuacji, poinformować o tym Administratora,</span></li>
<li><span>podjąć niezwłocznie wszelkie czynności mające na celu usunięcie naruszenia lub zagrożenia i zabezpieczenie danych osobowych w spos&oacute;b należyty przed dalszymi naruszeniami,</span></li>
<li><span>zebrać wszystkie możliwe dane i dokumenty, kt&oacute;re mogą pom&oacute;c w ustaleniu okoliczności naruszenia i przeciwdziałaniu podobnym sytuacjom w przyszłości,</span></li>
<li><span>udzielać Administratorowi wszelkich wyjaśnień.</span></li>
</ol>
<li><span>Podmiot przetwarzający oświadcza, że nie powołał Inspektora Ochrony Danych.</span></li>
<li><span>Podmiot przetwarzający oświadcza, że powierzone mu do przetwarzania Dane osobowe przetwarzane będą wyłącznie na terytorium Unii Europejskiej lub Europejskiego Obszaru Gospodarczego.**</span></li>

</ol>
<p align="center" style="margin-bottom: 0px; margin-top: 20px;">
  <strong>§4 Prawo kontroli</strong>
</p>
<ol>
<li><span>Administrator danych zgodnie z art. 28 ust. 3 pkt h) Rozporządzenia ma prawo kontroli &nbsp;&nbsp;&nbsp;i weryfikacji czy środki zastosowane przez Podmiot przetwarzający przy przetwarzaniu i zabezpieczeniu powierzonych danych osobowych spełniają postanowienia niniejszej umowy i Rozporządzenia. </span></li>
<li><span>Administrator danych realizować będzie prawo kontroli w godzinach pracy Podmiotu przetwarzającego i z minimum 3 dniowym jego uprzedzeniem.</span></li>
<li><span>Podmiot przetwarzający zobowiązuje się do usunięcia uchybień stwierdzonych podczas kontroli w terminie wskazanym przez Administratora danych nie dłuższym niż 7 dni.</span></li>
<li><span>Podmiot przetwarzający zobowiązuje się wsp&oacute;łpracować z Administratorem w zakresie prowadzonej kontroli, w tym w szczeg&oacute;lności zobowiązuje się:</span></li>
<ol>
<li><span>udostępnić Administratorowi wszelkie informacje i dokumenty niezbędne do przeprowadzenia kontroli, </span></li>
<li><span>dopuścić Administratora do obszaru przetwarzania danych osobowych oraz system&oacute;w informatycznych związanych z przetwarzaniem danych osobowych,</span></li>
<li><span>zapewnić Administratorowi możliwość przeprowadzenia rozm&oacute;w z pracownikami i wsp&oacute;łpracownikami Podmiotu przetwarzającego.</span></li>
</ol>
<li><span>Administrator danych jest uprawniony do wydawania Podmiotowi przetwarzającemu wiążących poleceń odnośnie sposobu wykonania niniejszej umowy.</span></li>
</ol>
<p align="center" style="margin-bottom: 0px; margin-top: 20px;">
  <strong>§5 Dalsze powierzenie danych do przetwarzania</strong>
</p>
<ol>
<li><span>Podmiot przetwarzający może powierzyć dane osobowe objęte niniejszą umową do dalszego przetwarzania podwykonawcom jedynie w celu wykonania umowy po uzyskaniu uprzedniej pisemnej zgody Administratora danych. &nbsp;</span></li>
<li><span>Przekazanie powierzonych danych do państwa trzeciego może nastąpić jedynie na pisemne polecenie Administratora danych chyba, że obowiązek taki nakłada na Podmiot przetwarzający prawo Unii lub prawo państwa członkowskiego, kt&oacute;remu podlega Podmiot przetwarzający. W takim przypadku przed rozpoczęciem przetwarzania Podmiot przetwarzający informuje Administratora danych o tym obowiązku prawnym, o ile prawo to nie zabrania udzielania takiej informacji z uwagi na ważny interes publiczny.</span></li>
<li><span>Podwykonawca, o kt&oacute;rym mowa w &sect; 5 ust. 1 winien spełniać te same gwarancje &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;i obowiązki jakie zostały nałożone na Podmiot przetwarzający w niniejszej umowie. </span></li>
<li><span>Podmiot przetwarzający ponosi pełną odpowiedzialność wobec Administratora za niewywiązanie się ze spoczywających na podwykonawcy obowiązk&oacute;w w zakresie ochrony danych osobowych.</span></li>
</ol>
<p align="center" style="margin-bottom: 0px; margin-top: 20px;">
  <strong>§6 Odpowiedzialność Podmiotu przetwarzającego</strong>
</p>
<ol>
<li><span>Podmiot przetwarzający jest odpowiedzialny za szkody wyrządzone Administratorowi, osobie fizycznej, kt&oacute;rej dane osobowe dotyczą lub innym osobom trzecim w związku z niewykonaniem lub nienależytym wykonaniem Umowy powierzenia, polegającym w szczeg&oacute;lności na działaniu niezgodnym z treścią Umowy powierzenia &nbsp;lub Rozporządzenia.</span></li>
<li><span>Podmiot przetwarzający jest odpowiedzialny za udostępnienie lub wykorzystanie danych osobowych niezgodnie z treścią umowy, a w szczeg&oacute;lności za udostępnienie powierzonych do przetwarzania danych osobowych osobom nieupoważnionym. </span></li>
<li><span>Podmiot przetwarzający odpowiada za działania i zaniechania os&oacute;b, przy pomocy kt&oacute;rych będzie przetwarzał powierzone dane osobowe, jak za działania lub zaniechania własne.</span></li>
<li><span>Podmiot przetwarzający zobowiązuje się do niezwłocznego poinformowania Administratora danych o jakimkolwiek postępowaniu, w szczeg&oacute;lności administracyjnym lub sądowym, dotyczącym przetwarzania przez Podmiot przetwarzający danych osobowych określonych w umowie, o jakiejkolwiek decyzji administracyjnej lub orzeczeniu dotyczącym przetwarzania tych danych, skierowanych do Podmiotu przetwarzającego, a także o wszelkich planowanych, &nbsp;o ile są wiadome, lub realizowanych kontrolach i inspekcjach dotyczących przetwarzania w Podmiocie przetwarzającym tych danych osobowych. Niniejszy ustęp dotyczy wyłącznie danych osobowych powierzonych przez Administratora danych. </span></li>
<li><span>W przypadku nałożenia na Administratora prawomocnej kary za niezgodne z prawem przetwarzanie danych osobowych przez Podmiot przetwarzający lub podwykonawcę, o kt&oacute;rym mowa w &sect; 5 ust. 1 Umowy, Podmiot przetwarzający zapłaci na rzecz Administratora karę umowną w wysokości ciężaru finansowego nałożonego na Administratora.</span></li>
<li><span>W przypadku, gdy w związku z niezgodnym z niniejszą umową i przepisami Rozporządzania przetwarzaniem danych osobowych powierzonych Podmiotowi przetwarzającemu, z przyczyn leżących po stronie Podmiotu przetwarzającego (wina), Administrator poniesie jakiekolwiek koszty, w szczeg&oacute;lności związane z wypłatą zadośćuczynienia lub koszty obsługi prawnej, Podmiot przetwarzający zobowiązany będzie pokrycia tych koszt&oacute;w w pełnej wysokości, a w przypadku wytoczonego postępowania sądowego - do udzielenia Administratorowi wszelkiego wsparcia w takim postępowaniu, a także do przejęcia odpowiedzialności w przypadku przyznania osobie fizycznej odszkodowania w takim postępowaniu, w wysokości odpowiadającej r&oacute;wnowartości przyznanego odszkodowania lub koszt&oacute;w zadośćuczynienia oraz wszelkich koszt&oacute;w niezbędnych do obrony przed zgłaszanymi roszczeniami a poniesionych przez Administratora w takim postępowaniu.</span></li>
</ol>
<p align="center" style="margin-bottom: 0px; margin-top: 20px;">
  <strong>§7 Czas obowiązywania umowy</strong>
</p>
<ol>
<li><span>Niniejsza umowa obowiązuje od dnia jej zawarcia przez cały &nbsp;czas obowiązywania Umowy podstawowej. </span></li>
<li><span>Podmiot przetwarzający zaprzestanie przetwarzania danych osobowych wraz z wygaśnięciem Umowy podstawowej, jak r&oacute;wnież na każde żądanie Administratora.</span></li>
<li><span>Każda ze stron może wypowiedzieć niniejszą umowę z zachowaniem miesięcznego okresu wypowiedzenia.</span></li>
</ol>
<p align="center" style="margin-bottom: 0px; margin-top: 20px;">
  <strong>§8 Rozwiązanie umowy</strong>
</p>
<ol>
<li><span>Niniejsza umowa została zawarta na czas obowiązywania Umowy podstawowej, przy czym rozwiązanie, wypowiedzenie lub wygaśnięcie Umowy podstawowej powoduje jednoczesne odpowiednio rozwiązanie, wypowiedzenie lub wygaśnięcie niniejszej umowy bez konieczności składania przez Strony dodatkowych oświadczeń w tym zakresie, chyba że Strony postanowią inaczej, z zastrzeżeniem kolejnych ustęp&oacute;w.</span></li>
<li><span>Administrator danych może rozwiązać niniejszą umowę ze skutkiem natychmiastowym, gdy Podmiot przetwarzający:</span></li>

<ol>
<li><span>pomimo zobowiązania go do usunięcia uchybień stwierdzonych podczas kontroli nie usunie ich w wyznaczonym terminie;</span></li>
<li><span>przetwarza dane osobowe w spos&oacute;b niezgodny z umową lub Rozporządzeniem;</span></li>
<li><span>powierzył przetwarzanie danych osobowych innemu podmiotowi bez zgody Administratora danych;</span></li>
</ol>

<li><span>Rozwiązanie umowy w trybie opisanym w ust. 2 powyżej następuje poprzez złożenie przez Administratora pisemnego oświadczenia Podmiotowi przetwarzającemu.</span></li>
<li><span>Strony zgodnie postanawiają, że rozwiązanie umowy powierzenia w spos&oacute;b określony w &nbsp;&nbsp;ust. 2 powyżej powoduje jednoczesne rozwiązanie Umowy podstawowej z winy Podmiotu przetwarzającego bez konieczności składania dodatkowych oświadczeń, chyba że co innego wynika z oświadczenia Administratora, o kt&oacute;rym mowa w ust. 3 powyżej.</span></li>

</ol>
<p align="center" style="margin-bottom: 0px; margin-top: 20px;">
  <strong>§9 Wzajemna komunikacja</strong>
</p>
<ol>
<li><span>W celu zapewnienia wzajemnej komunikacji w zakresie realizacji przedmiotu niniejszej umowy Strony wskazują poniżej do kontaktu następujące adresy poczty elektronicznej:</span></li>

<ol>
<li><span>po stronie Administratora: kadry@szkolamm.pl</span></li>
<li><span>po stronie Podmiotu przetwarzającego: {{email}}</span></li>
</ol>

<li><span>Zmiana adres&oacute;w poczty elektronicznej, o kt&oacute;rych mowa w ust. 1 nie wymaga zmiany niniejszej umowy i następuje poprzez wzajemne zawiadomienie przez Strony.</span></li>
<li><span>Strony zgodnie oświadczają, że osoby wskazane w pkt. 1 zostały poinformowane, iż administratorem ich danych osobowych jest odpowiednio Administrator lub Podmiot przetwarzający; dane osobowe będą przechowywane przez czas trwania umowy, a także po jej zakończeniu w celu wykonania obowiązk&oacute;w prawnych oraz dochodzenia wzajemnych roszczeń do czasu ich przedawnienia; odbiorcami danych są podmioty świadczące usługi archiwizacji i niszczenia dokument&oacute;w, firmy hostingowe oraz informatyczne, w tym podmioty obsługujące pocztę e-mail; mają prawo dostępu do swoich danych osobowych, żądania ich sprostowania, usunięcia, ograniczenia przetwarzania, prawo wniesienia sprzeciwu wobec przetwarzania danych oraz prawo do przenoszenia danych, a także prawo wniesienia skargi do organu nadzorczego w przypadku przetwarzania danych osobowych naruszającego przepisy prawa.</span></li>
</ol>
<p align="center" style="margin-bottom: 0px; margin-top: 20px;">
  <strong>§10 Zasady zachowania poufności</strong>
</p>
<ol>
<li><span>Podmiot przetwarzający zobowiązuje się do zachowania w tajemnicy wszelkich informacji, danych, materiał&oacute;w, dokument&oacute;w i danych osobowych otrzymanych od Administratora danych i od wsp&oacute;łpracujących z nim os&oacute;b oraz danych uzyskanych w jakikolwiek inny spos&oacute;b, zamierzony czy przypadkowy w formie ustnej, pisemnej lub elektronicznej (&bdquo;dane poufne&rdquo;).</span></li>
<li><span>Podmiot przetwarzający oświadcza, że w związku ze zobowiązaniem do zachowania w tajemnicy danych poufnych nie będą one wykorzystywane, ujawniane ani udostępniane bez pisemnej zgody Administratora danych w innym celu niż wykonanie Umowy, chyba że konieczność ujawnienia posiadanych informacji wynika z obowiązujących przepis&oacute;w prawa lub Umowy.</span></li>
<li><span>Obowiązek zachowania w tajemnicy danych poufnych obowiązuje w czasie trwania niniejszej umowy oraz przez okres 5 lat od jej rozwiązania (bez względu na przyczynę).</span></li>
</ol>
<p align="center" style="margin-bottom: 0px; margin-top: 20px;">
  <strong>§11 Postanowienia końcowe</strong>
</p>
<ol>
<li><span>Sądem właściwym dla rozpatrzenia spor&oacute;w wynikających z niniejszej umowy będzie sąd właściwy dla Administratora danych. </span></li>
<li><span>W sprawach nieuregulowanych zastosowanie będą miały przepisy Kodeksu cywilnego oraz Rozporządzenia.</span></li>
<li><span>Umowa została sporządzona w dw&oacute;ch jednobrzmiących egzemplarzach, po jednym dla każdej ze stron.</span></li>
</ol>
<p><br/></p>


<div class="cointainer" style="margin-top: 15px">
  <div class="left-cointainer">
    {{zamawiajacy}}<br>
    <span class="caption">Administrator danych</span>
  </div>
  <div class="right-cointainer">
    {{imieNazwisko}}<br>
    <span class="caption">Podmiot przetwarzający</span>
  </div>
</div>
</div>

</td></tr>
</tbody></table>
  </v-container>
</template>

<script>
export default {
  name: 'UmowaAngielskiWspolpraca',
  props: {
  },
  data () {
    return {
      zamawiajacy: '',
      imieNazwisko: '',
      nazwaFirmy: '',
      NIP: '',
      REGON: '',
      adresFirmy: '',
      korespondencyjnyFirmy: '',
      zamieszkany: '',
      pesel: '',
      nrRachunku: '',
      nrDowodu: '',
      nrTelefonu: '',
      email: '',
      umowaDo: '',
      wynagrodzenie: '',
      wynagrodzenieSlownie: ''
    }
  },
  created () {
    Object.entries(this.$route.query).forEach(
      ([key, value]) => { this[key] = value }
    )
  },
  methods: {
  },
  mounted () {
    if (this.zamawiajacy) {
      this.$nextTick(() => {
        window.setTimeout(() => window.print(), 300)
      })
    }
  }
}
</script>

<style scoped>
.page {
  size: 210mm 297mm;
  background-size: 100% 100%;
  line-height: 1.4;
  text-align: justify;
  margin-top: 0px;
  padding-top: 0px;
}
table, th, td {
  border: 1px;
  border-collapse: collapse;
}
.cointainer {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.cointainer-left {
  width: 20%;
}
.cointainer-right {
  width: 20%;
}
thead {
  display: table-header-group;
}
.table-border {
  border: 1px solid black;
  border-collapse: collapse;
  padding: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/UmowaWspolpracaAngielski.vue